import React from "react";
import { marinaDetailPath } from "@/lib/marinaUrls";

const SITE_URL = "https://marstick.com";

function slugify(value = "") {
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export default function MarinaItemListStructuredData({ marinas = [], lang = "en" }) {
  if (!marinas.length) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: marinas.map((marina, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: marina.name,
      url: `${SITE_URL}${marinaDetailPath(marina, lang)}`,
    })),
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}